import React, { useEffect, useState } from 'react';
import { TextField, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import InputContainer from '../../layout/inputContainer';
import { useForm } from "react-hook-form";
import { paymentStatus, registryStatus, uptodatePaymentStatus, yesOrNo } from '../../data';
import { useDispatch } from 'react-redux';
import { updateChecklistFormField } from '@egovernments/digit-ui-module-core/src/redux/actions/ownerEMOChecklist';
import { Table } from "react-bootstrap";
import ButtonWrapper from '../../components/Button';
import useModal from '@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal';


const EMOCheckList = ({ }) => {
    const sessionData = JSON.parse(sessionStorage.getItem("emoCheckList"))
    const defaultValues = {
        ...sessionData,  
    };
    const { handleSubmit, control, reset, watch } = useForm({defaultValues});
    const dispatch = useDispatch();
    const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
    const [regStatus, setregStatus] = useState("");
    const [storedData, setStoredData] = useState(null);
    const Modal = useModal()
    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateChecklistFormField(name, value));
        if (name === 'isPossesionAreaDiff') {
            setIsPossessionAreaDiff(value);
        } else if (name === 'registryStatus') {
            setregStatus(value)
        }
    };
    const onSubmit = (data) => {
        console.log(data, "data while submitting");
        Modal(
            "Checklist updated.",
            `Checklist Updated Successfully!`,
            "success",
          );
    };

    useEffect(() => {
        const storedChecklist = JSON.parse(sessionStorage.getItem("emoCheckList"));
        if (storedChecklist) {
            setStoredData(storedChecklist);
        }
    }, []);

    console.log(storedData, "storedDataaaaa");
    return (
        <section className="container1">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer" style={{ marginRight: '120px' }}>
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                            Estate Management Officer CheckList
                        </h2>
                    </div>
                    <div className="formInputContainer">
                        <Table striped bordered className="m-0" >
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Allotment Date</td>
                                    <td>
                                        <TextField
                                            label="Allotment Date"
                                            name="allotmentDate"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            onChange={handleChange}
                                            fullWidth
                                            defaultValue={storedData?.allotmentDate || null}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Registry/Agreement Status</td>
                                    <td>
                                        <Select
                                            label="Payment Status"
                                            name="registryStatus"
                                            onChange={handleChange}
                                            placeholder='Registry Status'
                                            fullWidth
                                            defaultValue={storedData?.registryStatus || null}
                                        >
                                            {registryStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                {regStatus === 'Done' && (
                                    <tr>
                                        <td>3</td>
                                        <td>Registry/Agreement Date</td>
                                        <td>
                                            <TextField
                                                label="Registry/Agreement Date"
                                                name="agreementDate"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={handleChange}
                                                fullWidth
                                                defaultValue={storedData?.agreementDate || null}
                                            />
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td>4</td>
                                    <td>Payment Status</td>
                                    <td>
                                        <Select
                                            label="Payment Status"
                                            name="paymentStatus"
                                            onChange={handleChange}
                                            placeholder='Payment Status'
                                            fullWidth
                                            defaultValue={storedData?.paymentStatus || null}
                                        >
                                            {paymentStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Up-to-date Payment Status</td>
                                    <td>
                                        <Select
                                            label="Up-to-date Payment Status"
                                            name="uptodatePaymentStatus"
                                            onChange={handleChange}
                                            placeholder='Uptodate Payment Status'
                                            fullWidth
                                            defaultValue={storedData?.uptodatePaymentStatus || null}
                                        >
                                            {uptodatePaymentStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Is Possession Area Different from Allotment</td>
                                    <td>
                                        <RadioGroup
                                            name="isPossesionAreaDiff"
                                            onChange={handleChange}
                                            defaultValue={storedData?.isPossesionAreaDiff || null}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                {isPossessionAreaDiff === 'yes' && (
                                    <tr>
                                        <td>7</td>
                                        <td>Area of Extra Land Allotted</td>
                                        <td>
                                            <TextField
                                                label="Area of Extra Land Allotted"
                                                name="areaOfExtraLand"
                                                placeholder='Area of Extra Land'
                                                type="text"
                                                onChange={handleChange}
                                                fullWidth
                                                defaultValue={storedData?.areaOfExtraLand || null}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                        />
                        
                    </div>
                </div>
            </form>
        </section>
    );
};

export default EMOCheckList;
